import { usersApi } from '../api/usersApi'
import type { UserCreateInput } from '../types/user'

export const addUser = async (user: UserCreateInput) => {
  try {
    const { data } = await usersApi.createUser(user)
    return data
  } catch (error) {
    console.error(`Error creating user: `, error)
    throw error
  }
}
